/* ------------------------------------------------------------------
   Filtrous - "We make science accessible." hero.

   2026-07-23 (David rev3, "this banner is awkward"): the band is two halves.
     LEFT  = the "We make science accessible." art, cropped tight to its
             content so it fills its half (the shipped original was ~45%
             empty cream, which is what read as "too much blank space").
     RIGHT = the two promo panels STACKED - Blue Dragon on top, BOGO below -
             each taking half the column height.

   The promo copy is REAL HTML now. It used to be baked into two 1500x500
   JPGs; at half-width that text rendered around 9-10px and was unreadable
   (David's complaint #1). Only the product illustration is still an image,
   cropped out of the original art onto its own navy ground.

   Layout, sizing and the mobile stack all live in filtrous-hero-nine.css.

   WHY THIS IS A SEPARATE FILE, not an edit inside filtrous-v3.js:
   that file is 74KB and this API can only rewrite whole files, so editing it
   in place means re-emitting all 74KB and risking silent corruption of the
   storefront app. Everything here is additive and removable by deleting this
   asset plus its two loader lines in sections/filtrous-v3-app.liquid.
------------------------------------------------------------------ */

(function () {
  "use strict";

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function cfg(k) { return (window.FV3_CONFIG && window.FV3_CONFIG[k]) || ""; }

  /* The two stacked promo cards. Headline splits into a white run and a teal
     run (<b>), matching the original art. The illustration is decorative -
     the link text already carries the meaning - so its alt is empty and the
     accessible name comes from the copy itself. */
  var PROMOS = [
    {
      cls:  "h9-promo-bd",
      href: "/collections/extraction-purification-v2",
      art:  "promoBlueDragonArtUrl",
      w: 437, h: 376,
      head: ["Blue Dragon", "extraction kits"],
      /* David 2026-07-23 rev6: one line. Was "Extraction & purification,
         guided by our <i>Glaucus</i> nudibranch - everything you need in one
         kit." The Glaucus reference is the part that got cut; it is still
         carried by the card title and by the nudibranch in the illustration. */
      body: "Everything you need in one kit.",
      cta:  "Shop the kits"
    },
    {
      cls:  "h9-promo-bogo",
      href: "/collections/on-sale-v2",
      art:  "promoBogoArtUrl",
      w: 608, h: 459,
      head: ["Buy one,", "get one free."],
      body: "Stock up while supplies last. Limited time only.",
      cta:  "Shop the sale"
    }
  ];

  function promoCard(p) {
    var art = cfg(p.art);
    return '<a class="h9-promo ' + p.cls + '" href="' + p.href + '">' +
      /* a div, not a span: <span> is phrasing content and may not contain
         <h3>/<p>. <a> itself is transparent, so block children are fine. */
      '<div class="h9-ptext">' +
        '<h3 class="h9-ph">' + esc(p.head[0]) + ' <b>' + esc(p.head[1]) + '</b></h3>' +
        '<span class="h9-prule" aria-hidden="true"></span>' +
        '<p class="h9-pb">' + p.body + '</p>' +
        '<span class="h9-pcta">' + esc(p.cta) + ' <span aria-hidden="true">&#8594;</span></span>' +
      '</div>' +
      (art
        ? '<img class="h9-part" src="' + esc(art) + '" alt=""' +
          ' width="' + p.w + '" height="' + p.h + '" loading="lazy" decoding="async" />'
        : '') +
      '</a>';
  }

  function markup() {
    var scene = cfg("bannerAccessibleUrl") || cfg("bannerLabUrl");
    var left = scene
      ? '<div class="h9-half h9-scene">' +
        '<img src="' + esc(scene) + '"' +
        ' alt="We make science accessible. Get your lab consumables from Filtrous today."' +
        ' width="1128" height="628" decoding="async" />' +
        '<a class="h9-nudilink" href="/pages/filtrous-field-guide-v2">' +
        'browse the nudibranches <span aria-hidden="true">&#8594;</span></a>' +
        '</div>'
      : '';

    var right = '<div class="h9-half h9-stack">' +
      PROMOS.map(promoCard).join("") +
      '</div>';

    /* art (left half) | Blue Dragon over BOGO (right half) */
    return '<div class="h9-cols">' + left + right + '</div>';
  }

  function placeHero() {
    /* .fv3-home-intro is rendered only by viewHome(), so its presence is
       itself the "are we on the home route" test - no hash parsing needed. */
    var intro = document.querySelector(".fv3-home-intro");
    if (!intro) return;
    if (document.querySelector(".fv3-hero9")) return;

    var hero = document.createElement("section");
    hero.className = "fv3-hero9";
    hero.setAttribute("aria-label", "We make science accessible");
    hero.innerHTML = markup();
    intro.parentNode.insertBefore(hero, intro);
  }

  function run() { placeHero(); }

  /* render() does shell.innerHTML = "" on every route change, so a one-shot
     pass would survive first paint and then vanish the first time someone
     navigates to a collection and back. Re-assert on every mutation instead;
     the guard in placeHero() makes repeat calls no-ops. */
  function boot() {
    run();
    var mount = document.getElementById("fv3-app") || document.body;
    new MutationObserver(run).observe(mount, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* ==================================================================
   OSK "Call for Quote" patch for the #/s/<q> SEARCH-RESULTS table
   The search table is built by filtrous-home-families.js and predates the
   OSK quote rule. This additive pass fixes the rendered table in place:
   OSK rows show "Call for Quote" with no Add control; when every result is
   OSK the Add column is dropped. Scoped to [data-hfsearch] only. Remove to revert.
   ================================================================== */
(function () {
  "use strict";
  var QUOTE_HTML = '<span class="fv3-quote" style="color:var(--navy,#082F4B);font-weight:400">Call for Quote</span>';
  function isOsk(sku) {
    var s = String(sku || "").toUpperCase();
    return s.indexOf("OSK") >= 0 || s === "EXK-BD-0096-PP";
  }
  function fixTable(tbl) {
    var tbody = tbl.tBodies && tbl.tBodies[0];
    if (!tbody) return;
    var rows = [];
    for (var i = 0; i < tbody.rows.length; i++) {
      var tr = tbody.rows[i];
      if (tr.className && tr.className.indexOf("fv3-group") !== -1) continue;
      rows.push(tr);
    }
    if (!rows.length) return;
    var flags = [], allOsk = true;
    for (var r = 0; r < rows.length; r++) {
      var pc = rows[r].querySelector(".fv3-part");
      var osk = pc ? isOsk(pc.textContent) : false;
      flags.push(osk);
      if (!osk) allOsk = false;
    }
    if (allOsk && tbl.tHead && tbl.tHead.rows[0] && !tbl.hasAttribute("data-oskq-head")) {
      var hr = tbl.tHead.rows[0], lastTh = hr.cells[hr.cells.length - 1];
      if (lastTh && /add/i.test(lastTh.textContent)) lastTh.parentNode.removeChild(lastTh);
      tbl.setAttribute("data-oskq-head", "1");
    }
    for (var j = 0; j < rows.length; j++) {
      var row = rows[j];
      if (row.getAttribute("data-oskq") === "1") continue;
      if (!flags[j]) { row.setAttribute("data-oskq", "1"); continue; }
      var price = row.querySelector(".fv3-price");
      if (price) price.innerHTML = QUOTE_HTML;
      var last = row.cells[row.cells.length - 1];
      if (allOsk) { if (last) last.parentNode.removeChild(last); }
      else if (last) { last.innerHTML = ""; }
      row.setAttribute("data-oskq", "1");
    }
  }
  function pass() {
    var boxes = document.querySelectorAll("#fv3-app [data-hfsearch]");
    for (var i = 0; i < boxes.length; i++) {
      var tbl = boxes[i].querySelector("table.fv3-table");
      if (tbl) fixTable(tbl);
    }
  }
  function boot() {
    pass();
    var mount = document.getElementById("fv3-app") || document.body;
    new MutationObserver(pass).observe(mount, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
